(() => {
  if (customElements.get('ow-account-icon')) return;
  class OWAccountIcon extends HTMLElement {
    connectedCallback() {
      this.cancelled = false;
      customElements.whenDefined('shopify-account').then(() => {
        if (this.cancelled || !this.isConnected) return;
        let attempts = 0;
        const connect = () => {
          const root = this.querySelector('shopify-account')?.shadowRoot;
          if (!root) return false;
          this.sync(root);
          this.observer = new MutationObserver(() => this.sync(root));
          this.observer.observe(root, { childList: true, subtree: true });
          return true;
        };
        if (!connect()) this.timer = setInterval(() => {
          if (this.cancelled || connect() || ++attempts >= 50) clearInterval(this.timer);
        }, 100);
      });
    }
    sync(root) {
      const button = root.querySelector('.wrapper > .account-button');
      if (!button) {
        this.removeAttribute('data-icon-ready');
        return;
      }
      if (!root.getElementById('ow-account-icon-style')) {
        const style = document.createElement('style');
        style.id = 'ow-account-icon-style';
        style.textContent = `
          .wrapper > .account-button {
            display: flex !important; align-items: center !important; justify-content: center !important;
            width: 100% !important; height: 44px !important; min-height: 44px !important;
            padding: 0 !important; background: transparent !important; color: inherit !important;
          }
          .wrapper > .account-button > * { display: none !important; }
          .wrapper > .account-button::before { content: none !important; }
          .wrapper > .account-button::after {
            content: '' !important; display: block !important; width: 22px !important; height: 22px !important;
            flex: 0 0 22px !important; background: currentColor !important;
            mask: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20448%20512%22%3E%3Cpath%20d%3D%22M313.6%20304c-28.7%200-42.5%2016-89.6%2016-47.1%200-60.8-16-89.6-16C60.2%20304%200%20364.2%200%20438.4V464c0%2026.5%2021.5%2048%2048%2048h352c26.5%200%2048-21.5%2048-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400%20464H48v-25.6c0-47.6%2038.8-86.4%2086.4-86.4%2014.6%200%2038.3%2016%2089.6%2016%2051.7%200%2074.9-16%2089.6-16%2047.6%200%2086.4%2038.8%2086.4%2086.4V464zM224%20288c79.5%200%20144-64.5%20144-144S303.5%200%20224%200%2080%2064.5%2080%20144s64.5%20144%20144%20144zm0-240c52.9%200%2096%2043.1%2096%2096s-43.1%2096-96%2096-96-43.1-96-96%2043.1-96%2096-96z%22%2F%3E%3C%2Fsvg%3E") center / contain no-repeat;
            -webkit-mask: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20448%20512%22%3E%3Cpath%20d%3D%22M313.6%20304c-28.7%200-42.5%2016-89.6%2016-47.1%200-60.8-16-89.6-16C60.2%20304%200%20364.2%200%20438.4V464c0%2026.5%2021.5%2048%2048%2048h352c26.5%200%2048-21.5%2048-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400%20464H48v-25.6c0-47.6%2038.8-86.4%2086.4-86.4%2014.6%200%2038.3%2016%2089.6%2016%2051.7%200%2074.9-16%2089.6-16%2047.6%200%2086.4%2038.8%2086.4%2086.4V464zM224%20288c79.5%200%20144-64.5%20144-144S303.5%200%20224%200%2080%2064.5%2080%20144s64.5%20144%20144%20144zm0-240c52.9%200%2096%2043.1%2096%2096s-43.1%2096-96%2096-96-43.1-96-96%2043.1-96%2096-96z%22%2F%3E%3C%2Fsvg%3E") center / contain no-repeat;
          }
        `;
        root.append(style);
      }
      this.setAttribute('data-icon-ready', '');
    }
    disconnectedCallback() {
      this.cancelled = true;
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.observer = null;
    }
  }
  customElements.define('ow-account-icon', OWAccountIcon);
})();

